import React from 'react'
import {useRouter} from "next/router";
import {useSelector,useDispatch} from "react-redux";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";

// components
import {OtherSet} from "./preset/otherSet";
import {SelectSet} from "./preset/selectSet";
import {BloodTest} from "./preset/bloodTest";
import {HealthCondition} from "./preset/healthCondition";
import {ItemFeature} from "./preset/itemFeature";
import {Diseases} from "./preset/diseases";
import {css} from "@emotion/react";
import colorPalette from "../../../../../styles/theme/colorPalette";
import Container from "@material-ui/core/Container";

export const PresetTab = (props) => {
  const tabId = useSelector((state) => state.searchDrawerTab.id)
  
  const searchType = 'searchPreset'
  
  const [expanded, setExpanded] = React.useState(false);
  
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  
  return (
      <>
        {
          props.value === tabId &&
         　<Container maxWidth={'lg'} css={{marginTop: '16px'}}>
            {/*<Accordion expanded={expanded === 'otherSet'} onChange={handleChange('otherSet')}>*/}
            {/*  <AccordionSummary>*/}
            {/*    <Typography>特別セットから探す</Typography>*/}
            {/*  </AccordionSummary>*/}
            {/*  <AccordionDetails>*/}
            {/*    <OtherSet/>*/}
            {/*  </AccordionDetails>*/}
            {/*</Accordion>*/}
            {/*<Accordion expanded={expanded === 'selectSet'} onChange={handleChange('selectSet')}>*/}
            {/*  <AccordionSummary>*/}
            {/*    <Typography>栄養士セレクトセットから探す</Typography>*/}
            {/*  </AccordionSummary>*/}
            {/*  <AccordionDetails>*/}
            {/*    <SelectSet/>*/}
            {/*  </AccordionDetails>*/}
            {/*</Accordion>*/}
            <Accordion disableGutters elevation={0} square={true} expanded={expanded === 'bloodTest'} TransitionProps={{ unmountOnExit: true }} onChange={handleChange('bloodTest')} css={accordionStyle}>
              <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  css={accordionSummaryStyle}
                  expandIcon={<ExpandMoreIcon />}
              >
                <Typography>血液検査から探す</Typography>
              </AccordionSummary>
              <AccordionDetails css={accordionDetailsStyle}>
                <BloodTest searchType={'bloodTest'}/>
              </AccordionDetails>
            </Accordion>
            <Accordion disableGutters elevation={0} square={true} expanded={expanded === 'healthCondition'} TransitionProps={{ unmountOnExit: true }} onChange={handleChange('healthCondition')} css={accordionStyle}>
              <AccordionSummary
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                  css={accordionSummaryStyle}
                  expandIcon={<ExpandMoreIcon />}>
                <Typography>健康状況から探す</Typography>
              </AccordionSummary>
              <AccordionDetails css={accordionDetailsStyle}>
                <HealthCondition searchType={searchType}/>
              </AccordionDetails>
            </Accordion>
            <Accordion disableGutters elevation={0} square={true} expanded={expanded === 'itemFeature'} TransitionProps={{ unmountOnExit: true }} onChange={handleChange('itemFeature')} css={accordionStyle}>
              <AccordionSummary
                  aria-controls="panel3a-content"
                  id="panel3a-header"
                  css={accordionSummaryStyle}
                  expandIcon={<ExpandMoreIcon />}>
                <Typography>商品特徴から探す</Typography>
              </AccordionSummary>
              <AccordionDetails css={accordionDetailsStyle}>
                <ItemFeature searchType={searchType}/>
              </AccordionDetails>
            </Accordion>
            <Accordion disableGutters elevation={0} square={true} expanded={expanded === 'diseases'} TransitionProps={{ unmountOnExit: true }} onChange={handleChange('diseases')} css={accordionStyle}>
              <AccordionSummary
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  css={accordionSummaryStyle}
                  expandIcon={<ExpandMoreIcon />}>
                <Typography>疾病から探す</Typography>
              </AccordionSummary>
              <AccordionDetails css={accordionDetailsStyle}>
                <Diseases searchType={searchType}/>
              </AccordionDetails>
            </Accordion>
          </Container>
        }
      </>
  )
}

const accordionStyle = css`
  margin: 16px auto;
  max-width: 540px;
  border: solid 1px ${colorPalette.lightgray};
  border-radius: 8px;
  overflow: hidden;
  &::before {
    background-color: white;
  }
`

const accordionSummaryStyle = css`
  vertical-align: middle;
  p {
    font-size: 1.8rem;
    font-weight: 500;
  }
  > div {
    justify-content: center;
  }
  .MuiAccordionSummary-expandIconWrapper {
    position: absolute;
    right: 20px;
    color: ${colorPalette.primary};
  }
`

const accordionDetailsStyle = css`
  border-top: solid 1px ${colorPalette.lightgray};
  padding: 16px;
`